import {makeBFFApiUrl} from 'main/factories/http';

import {GetAuthorizationsOdontoTrack} from 'domain/usecases/private/authorizations/get-authorizations-odonto-track';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetAuthorizationsOdontoTrack} from 'data/usecases/private/authorizations-odonto/remote-get-authorizations-odonto-track';
import {authorizationsOdontoFlowEndpoints} from '../../endpoints';

export const makeGetAuthorizationsOdontoTrack = (): GetAuthorizationsOdontoTrack =>
	new RemoteGetAuthorizationsOdontoTrack(
		makeBFFApiUrl(authorizationsOdontoFlowEndpoints.authorizationsOdontoTrack),
		makeAuthorizeHttpClientDecorator(),
	);
